import type { IconType } from "react-icons";
import { IoMdCall } from "react-icons/io";
import { MdGroups } from "react-icons/md";
import { PiShootingStarThin } from "react-icons/pi";

/** Structural data only — translated copy lives in dict.home.bookAMeeting. */
export const bookAMeetingImages = {
  image1: "/assets/book-a-meeting/home-section/1.avif",
  imageAlt1: "booking a meeting 1",
  image2: "/assets/book-a-meeting/home-section/2.avif",
  imageAlt2: "booking a meeting 2",
  image3: "/assets/book-a-meeting/home-section/3.avif",
  imageAlt3: "booking a meeting 3",
  image4: "/assets/book-a-meeting/home-section/4.avif",
  imageAlt4: "booking a meeting 4",
};

export type BookAMeetingStepKey = "initiateStrategy" | "shapeTeam" | "beginJourney";

/** Structural step data — icon + stable key. Title/description from dict. */
export const bookAMeetingSteps: { id: number; key: BookAMeetingStepKey; icon: IconType }[] = [
  { id: 1, key: "initiateStrategy", icon: IoMdCall },
  { id: 2, key: "shapeTeam", icon: MdGroups },
  { id: 3, key: "beginJourney", icon: PiShootingStarThin },
];
